import { useField } from 'formik'
import { Attachment } from '../../../../../../../api/types'
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'

const AttachmentContext = createContext<{
  loading: boolean
  attachment: File | Attachment
  removeAttachment: () => void
  addAttachment: (file: File | Attachment) => void
}>(null)

export function useAttachments() {
  return useContext(AttachmentContext)
}

type Props = { children: ReactNode; name: string }
export function AttachmentsProvider({ children, name }: Props) {
  const [field, , helpers] = useField(name)
  const [attachment, setAtt] = useState<File | Attachment>(null)

  useEffect(() => {
    if (field.value === 'reset') {
      setAtt(null)
      helpers.setValue(null)
    }
  }, [field.value, helpers])

  return (
    <AttachmentContext.Provider
      value={{
        attachment,
        loading: attachment && '_id' in attachment === false,
        removeAttachment() {
          setAtt(null)
          helpers.setValue([])
        },
        addAttachment(file: File | Attachment) {
          setAtt(file)
          if (file && '_id' in file) {
            helpers.setValue([file._id])
          }
        },
      }}
    >
      {children}
    </AttachmentContext.Provider>
  )
}
